import React from "react";
import {connect} from 'react-redux';
import { Modal, Button, Typography } from "antd";
import { useHistory } from 'react-router-dom'
import HttpRequest from "../../../../utils/HttpRequest";
import CustomIcon from "../../../../utils/components/CustomIcon/CustomIcon";
import { deleteCaseRequest } from "../../CaseApiActions";
import Notification from "../../../../utils/Notification";

const notification = new Notification()
const { Title } = Typography

let DeleteCase = (props) => {
  const { isModalOpen, setIsModalOpen, onDelete, caseDetails } = props
  const history = useHistory()

  const handleDelete = () => {
    props.deleteCase(caseDetails.id).then(() => {
      notification.show('info', "Delete Case", "Case is deleted");
      setIsModalOpen(false)
    }).finally(() => onDelete())
    // // create case
    // new HttpRequest(null, `/cases/${caseDetails.id}`, 'delete')
    //   .send()
    //   .then(res => {
    //     setIsModalOpen(false); // Close modal
    //   }).catch((err) => {
    //   });
    // // TODO: delete case
    // onDelete()
  };

  const handleCancel = () => {
    setIsModalOpen(false); // Close modal
  };

  return (
    (<Modal
      title={
        <div className="flex-horizontal-gap-4">
          <CustomIcon name="DeleteTrash" width={40} height={40} />
          <Typography.Title level={2} style={{ margin: 0 }}>Delete Case</Typography.Title>
        </div>
      }
      open={isModalOpen}
      onCancel={handleCancel}
      footer={null}
    >
      <div className="flex-vertical-gap-2">
        <div>This action can not be undone.</div>
        <Button type="primary" block onClick={handleDelete}>
          Delete Case
          <CustomIcon name="DeleteTrash" />
        </Button>
        <Button block onClick={handleCancel}>
          Cancel
          <CustomIcon name="CloseX" />
        </Button>
      </div>
    </Modal>)
  );
};

const mapStateToProps = (state) => {
  return {
    cases: state.caseReducer.cases,
    loggedInUserId: state.auth.loggedInUser.id,
    currentRole: state.auth.currentRole
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    deleteCase: (id) => {
      return dispatch(deleteCaseRequest(id)).then((data) => {
        return Promise.resolve(data);
      }, (error) => {
        return Promise.reject(error);
      });
    }
  }
};

DeleteCase = connect(
  mapStateToProps,
  mapDispatchToProps
)(DeleteCase);

export default DeleteCase;
